module.exports = __webpack_public_path__ + "img/中国科学院体育协会@3x.f9409f51.png";